<template>
  <div class="checkbox">
    <TabManager
      :tabList="tabs"
      :defaultTabKey="defaultTabKey"
      @tab-click="handleCheckboxClick"
    ></TabManager>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { TabManager } from '@n11/so-ui-components';
import { ProductStatus } from '../../utils/enum/productStatus';
import { defineEmits } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const store = useStore();

const tabs = ref([]);
const tabKeys = ref([]);
const defaultTabKey = ref(1);
const route = useRoute();
const router = useRouter();

const getTabCount = async () => {
  try {
    const data = await store.dispatch("products/getTabCount");

    const mainTabs = [];
    const subTabsByKey = {};

    for (const tab of data.tabs ?? []) {
      const parentKey = tab.searchParam;
      mainTabs.push({
        key: parentKey,
        label: `${tab.displayName}<br><span class="count">(${tab.count ?? 0})</span>`,
      });

      if (Array.isArray(tab.subTabs) && tab.subTabs.length) {
        subTabsByKey[parentKey] = tab.subTabs.map(st => ({
          id: st.searchParam,
          name: st.displayName,
        }));
        store.commit('products/SET_SUB_TABS_BY_KEY', { key: parentKey, subTabs: subTabsByKey[parentKey] });
      }
    }

    tabs.value = mainTabs.map(i => i.label);
    tabKeys.value = mainTabs.map(i => i.key);
  } catch (e) {
    console.error('Tablar yüklenemedi:', e);
  }
};

const emit = defineEmits(['filterEmitter', 'tab-click']);

const handleCheckboxClick = (index, sendProductStatus = true) => {
  const productStatusMapping = {
    all_products: ProductStatus.ALL_PRODUCTS,
    on_sale: ProductStatus.ON_SALE,
    sold: ProductStatus.ON_SALE,
    not_on_sale: ProductStatus.OUT_OF_STOCK,
    pending_actions: [],
    pending_approval: ProductStatus.APPROVAL_PENDING,
  };
  const selectedKey = tabKeys.value[index];

  const filterPayload = {
    productTitle: null,
    stockCode: null,
    pimsId: null,
    gtin: null,
    modelCode: null,
    id: null,
    categoryIds: null,
    brandName: null,
    n11Warehouse: null,
    productStatus: sendProductStatus ? productStatusMapping[selectedKey] : null,
    productInApprovalReason:
      productStatusMapping[selectedKey] == "pending_actions" ? [] : null,
    pageRequest: {
      sortOrders: null,
      pageNumber: "0",
      pageSize: "10",
    },
    tabParam: selectedKey,
  };

    emit('filterEmitter', filterPayload);
    emit('tab-click', selectedKey);

  store.commit("products/SET_PRODUCT_LIST_ACTIVE_TAB", tabKeys.value[index]);
  router.replace({
    name: route.name,
    query: { ...route.query, tab: undefined },
  });
};

onMounted(async () => {
  await getTabCount();
  const tabParam = route.query.tab;

    if (tabParam) {
        const tabIndex = tabKeys.value.indexOf(tabParam);

        if (tabIndex !== -1) {
            defaultTabKey.value = tabIndex;
        }
    } else {
        handleCheckboxClick(defaultTabKey.value, false);
    }
});

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';


.checkbox {
    display: flex;
    width: 1320px;
    height: 64px;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
}

.filters-box {
    display: flex;
    width: 1320px;
    padding: 16px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
}

.hidden-checkbox {
    display: none;
}

.button-label {
    display: inline-block;
    padding: 12px 32px;
    font-size: 16px;
    color: #242424;
    background-color: #fff;
    border: 1px solid #B3BBCB;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: -0.05px;
}

.hidden-checkbox:checked + .button-label {
  background-color: #f2f0fa;
  border-color: #5d3ebc;
  color: #5d3ebc;
}
</style>
